import type { Ref } from 'vue';
export interface EditorOption {
  icon?: any;
  title: string;
  text?: string | Ref<string>;
  disabled?: boolean;
  loseFocus?: boolean;
  showArrow?: boolean;
  type?: string;
  component?: any;
  props?: Record<string, any>;
  action?: (arg?: any) => void;
  isActive?: () => boolean;
}

import { getDirectionOptions } from '../menuOptions/directionOptions';
import { getAlignmentOptions } from '../menuOptions/alignmentOptions';
import { getIndentOptions } from '../menuOptions/indentOptions';
import { getSpacingOptions } from '../menuOptions/lineHeightOptions';
import { getBulletListOptions } from '../menuOptions/bulletListOptions';
import { getOrderedListOptions } from '../menuOptions/orderedListOptions';
import { getHorizontalRuleOptions } from '../menuOptions/horizontalRule';
import { getImageResizerOptions } from '../menuOptions/imageResizer';
import { getTooltipOptions } from '../menuOptions/tooltipOptions';
import { getLinkOptions } from '../menuOptions/linkOptions';
import { getTableOptions } from '../menuOptions/tableOptions';
import { getBackgroundOptions } from '../menuOptions/backGroundOptions';
import { getHighlightOptions } from '../menuOptions/highlightOptions';
import { getColorOptions } from '../menuOptions/colorOptions';
import { getBoldOptions } from '../menuOptions/boldOption';
import { getItalicOptions } from '../menuOptions/italicOption';
import { getUnderlineOptions } from '../menuOptions/underlineOption';
import { getStrikeOptions } from '../menuOptions/strikeOption';
import { getBlockQuoteOptions } from '../menuOptions/blockQuoteOption';
import { gettextTypeOptions } from '../menuOptions/textTypeOptions';
import { getfontSizeOptions } from '../menuOptions/fontSizeOptons';
import { getClearTextOptions } from '../menuOptions/clearTextOpton';
import { getMathKatexOptions } from '../menuOptions/mathKatexOpton';

export function useEditorOptions(
  id: string,
  alignmentRef: Ref,
  directionRef: Ref,
  typographyRef: Ref,
  fontSizeOptions: () => Array<any>,
): { options: EditorOption[] }[] {
  return [
    {
      options: [getDirectionOptions(id, directionRef)],
    },
    {
      options: [
        getAlignmentOptions(id, alignmentRef),
        getIndentOptions(id, true),
        getIndentOptions(id, false),
        getSpacingOptions(id),
        getBulletListOptions(id),
        getOrderedListOptions(id),
        getHorizontalRuleOptions(id),
      ],
    },
    {
      options: [
        getImageResizerOptions(id),
        getTooltipOptions(id),
        getLinkOptions(id),
        getTableOptions(id),
      ],
    },

    {
      options: [
        getBackgroundOptions(id),
        getHighlightOptions(id),
        getColorOptions(id),
        getBoldOptions(id),
        getItalicOptions(id),
        getUnderlineOptions(id),
        getStrikeOptions(id),
        getBlockQuoteOptions(id),
      ],
    },
    {
      options: [getMathKatexOptions(id)],
    },
    {
      options: [
        gettextTypeOptions(id, typographyRef),
        getfontSizeOptions(id, fontSizeOptions),
      ],
    },

    {
      options: [getClearTextOptions(id)],
    },
  ];
}
